module.exports = __webpack_public_path__ + "media/images/app/pro-beb75b46d5ed08de15d3bb867ad056c8.svg";